import { ConfigProviderProps } from "antd";
import zh_CN from "antd/locale/zh_CN";

import { PrimaryTheme } from "./theme";

/**
 * 配置 antd 的主题
 */
export const AntDesignConfigProviderConfiguration: ConfigProviderProps = {
  locale: zh_CN,
  theme: {
    cssVar: true,
    hashed: false,
    ...PrimaryTheme,
  },
};
